// Amazon/Rainforest import wraps the brand as "Visit the <Brand> Store" or "Brand: <Brand>"; brand cells show just
// the brand. " Store" is optional and stripped only with the prefix — the 40-char server cap truncates long values.
export const cleanBrandTitle = (subTitle: string): string =>
  subTitle
    .replace(/^\s*Visit\s+(?:the\s+)?(.+?)(?:\s+Store)?\s*$/i, '$1')
    .replace(/^\s*Brand:\s*/i, '')
    .trim()
